import React, { FC } from 'react';
import { head } from 'ramda';
import { captureException } from '@sentry/react';
import {
  FileAwarenessMonitorErrorsList,
  FileAwarenessMonitorErrorTypeTag,
  withFileUsedParam,
} from '@wix/media-manager-shared';

import { MediaManagerSDKFile } from '../../../../utils/media-manager-sdk';
import { useVideoPreviews } from '../../../../utils/media-manager-sdk/hooks';
import { IOuter } from '../ItemDemonstration.types';

export const PublicVideo: FC<IOuter> = ({ item, className, saveRef }) => (
  <div className={className} data-hook="expanded-view-public-video-demonstration" ref={saveRef}>
    <video
      src={withFileUsedParam(head(useVideoPreviews(item as MediaManagerSDKFile)), {
        logger: (error) =>
          captureException(error, {
            tags: {
              [FileAwarenessMonitorErrorTypeTag]: FileAwarenessMonitorErrorsList.FailedToAppendParameter,
            },
          }),
      })}
      loop
      autoPlay
      width="100%"
      height="100%"
    />
  </div>
);
